import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const categoryAdd = createAsyncThunk(
  "category/categoryAdd",
  async ({ name, image, location }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      formData.append("location", location);
      const { data } = await api.post("/category-add", formData, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_category = createAsyncThunk(
  "category/get_category",
  async ({ parPage, page, searchValue }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(
        `/category-get?page=${page}&&searchValue=${searchValue}&&parPage=${parPage}`,
        { withCredentials: true }
      );
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const delete_category = createAsyncThunk(
  "category/delete_category",
  async (categoryId, { rejectWithValue }) => {
    try {
      const { data } = await api.post(`/delete_category/${categoryId}`, null, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const get_single_category = createAsyncThunk(
  "category/get_single_category",
  async (categoryId, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/category-get/${categoryId}`, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

export const update_category = createAsyncThunk(
  "category/update_category",
  async ({ name, image, location, categoryId }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("image", image);
      formData.append("location", location);
      formData.append("categoryId", categoryId);

      const { data } = await api.post(`/category-update`, formData, {
        withCredentials: true,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { error: "Server error" });
    }
  }
);

const categorySlice = createSlice({
  name: "category",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    loader2: false,
    categorys: [],
    category: null,
    totalCategory: 0,
  },
  reducers: {
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [categoryAdd.pending]: (state) => {
      state.loader = true;
    },
    [categoryAdd.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [categoryAdd.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.categorys.push(payload.category);
    },

    [get_category.pending]: (state) => {
      state.loader = true;
    },
    [get_category.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_category.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.categorys = payload.categorys;
      state.totalCategory = payload.totalCategory || 0;
    },

    [get_single_category.pending]: (state) => {
      state.loader2 = true;
    },
    [get_single_category.rejected]: (state, action) => {
      state.loader2 = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [get_single_category.fulfilled]: (state, { payload }) => {
      state.loader2 = false;
      state.category = payload.category;
    },

    [update_category.pending]: (state) => {
      state.loader2 = true;
    },
    [update_category.rejected]: (state, action) => {
      state.loader2 = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [update_category.fulfilled]: (state, { payload }) => {
      state.loader2 = false;
      state.successMessage = payload.message;
      state.category = payload.category;
    },

    [delete_category.pending]: (state) => {
      state.loader = true;
    },
    [delete_category.rejected]: (state, action) => {
      state.loader = false;
      state.errorMessage = action.payload?.error || action.error.message || "Something went wrong";
    },
    [delete_category.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.successMessage = payload.message;
      state.categorys = state.categorys.filter(
        (category) => category._id !== payload.deletedCategoryId
      );
    },
  },
});

export const { messageClear } = categorySlice.actions;
export default categorySlice.reducer;
